module.exports = __webpack_public_path__ + "img/512.48632892.png";